import { useEffect, useState, useRef } from 'react';
import { Form, Modal, Input, Button } from 'antd';

import { useCarMentenanceContext } from './carMaintenanceProvider';

const initialFormValues = {
  id: null,
  img_path: '',
  name: '',
  description: '',
};

export default function CarTypesEditModal({ typeData, onClose }) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [carTypesEditForm] = Form.useForm();
  const editAction = useRef(false);

  const { isLoading, createCarType } = useCarMentenanceContext();

  useEffect(() => {
    if (typeData === undefined) return;

    editAction.current = !!typeData;

    const dataToUse = typeData || initialFormValues;
    if (dataToUse.id !== null && dataToUse.id !== undefined) {
      carTypesEditForm.setFieldsValue(dataToUse);
    } else {
      carTypesEditForm.resetFields();
    }

    setIsModalVisible(true);
  }, [carTypesEditForm, typeData]);

  const handleModalReset = () => {
    carTypesEditForm.resetFields();
    setIsModalVisible(false);
    onClose();
  };

  const handleModalOnFinish = async () => {
    const submitData = carTypesEditForm.getFieldsValue();
    const encodedImgPath = {
      ...submitData,
      img_path: btoa(submitData.img_path),
    };

    console.log('submitData:', encodedImgPath);
    await createCarType(encodedImgPath, submitData.id);
    handleModalReset();
  };

  return (
    <Modal
      title={editAction.current ? '編輯車型' : '新增車型'}
      open={isModalVisible}
      onCancel={handleModalReset}
      footer={null}>
      <Form
        form={carTypesEditForm}
        name="carTypesEditForm"
        onFinish={handleModalOnFinish}>
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>
        <Form.Item
          label="照片URL"
          name="img_path"
          rules={[
            { required: true, message: '請輸入車型照片URL' },
            { type: 'url', message: '請輸入合法的網址格式' },
          ]}>
          <Input allowClear />
        </Form.Item>
        <Form.Item
          label="車型型號"
          name="name"
          rules={[{ required: true, message: '請輸入車型型號' }]}>
          <Input allowClear />
        </Form.Item>
        <Form.Item
          label="車型名稱"
          name="description"
          rules={[{ required: true, message: '請輸入車型名稱' }]}>
          <Input allowClear />
        </Form.Item>
        <div style={{ textAlign: 'right', marginTop: '24px' }}>
          <Button onClick={handleModalReset} style={{ marginRight: '8px' }}>
            關閉
          </Button>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            提交
          </Button>
        </div>
      </Form>
    </Modal>
  );
}
